import { render } from "./sliderArea.vue?vue&type=template&id=9ce2d1f6"
import script from "./sliderArea.vue?vue&type=script&lang=js"
export * from "./sliderArea.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Merlin.Website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__